import { Box, HStack, List, ListItem, Radio, Text, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { PricingPlan } from '@services/appsync/types';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type PricingPlanOptionProps = {
  label: string;
  pricingPlan: PricingPlan;
  description?: string;
  points: string[];
  featured?: boolean;
};

export const PricingPlanOption: React.FC<PricingPlanOptionProps> = ({
  featured = false,
  label,
  description,
  points = [],
  pricingPlan,
}) => {
  const VALUE: Record<PricingPlan, number> = {
    [PricingPlan.FAKE_FIFTY_DOLLARS_PER_YEAR_UNDER_5K]: 50,
    [PricingPlan.FAKE_FIVE_DOLLARS_UNDER_5K]: 5,
    [PricingPlan.FIFTY_DOLLARS_PER_YEAR_UNDER_5K]: 50,
    [PricingPlan.FIVE_DOLLARS_UNDER_5K]: 5,
  };

  const TERM: Record<PricingPlan, string> = {
    [PricingPlan.FAKE_FIFTY_DOLLARS_PER_YEAR_UNDER_5K]: 'year',
    [PricingPlan.FAKE_FIVE_DOLLARS_UNDER_5K]: 'month',
    [PricingPlan.FIFTY_DOLLARS_PER_YEAR_UNDER_5K]: 'year',
    [PricingPlan.FIVE_DOLLARS_UNDER_5K]: 'month',
  };

  return (
    <VStack
      as="label"
      position="relative"
      border="1px solid rgba(0,0,0,0.1)"
      backgroundColor={featured ? 'blue.400' : 'white'}
      borderRadius="15px"
      color={featured ? 'white' : 'black'}
      cursor="pointer"
      width="full">
      {featured && (
        <Box position="absolute" top="-8px" right="8px">
          <Box backgroundColor={'black'} position="absolute" height="8px" width="64px" top="0" right={0} />
          <Box
            position="absolute"
            top="0"
            right="0"
            width="0"
            height="0"
            borderStyle="solid"
            borderWidth="0 64px 64px 0"
            borderColor="transparent #171f2A transparent transparent"></Box>
          <Icon icon="star" color={'white'} position="absolute" right="10px" top="10px" boxSize="18px" />
        </Box>
      )}
      <VStack w="full" gap="0" borderTopLeftRadius={'15px'} borderTopRightRadius={'15px'} padding="20px">
        <Box
          as="label"
          display="inline-flex"
          position="absolute"
          top="12px"
          left="12px"
          border={featured ? `2px solid white` : `2px solid rgba(0,0,0,0.3)`}
          borderRadius={'50%'}>
          <Radio value={pricingPlan} border="none" />
        </Box>
        <TextBlock weight="bold" fontSize={'24px'} lineHeight={'18px'}>
          {label}
        </TextBlock>
        {description && <Text color={featured ? 'rgba(255,255,255,0.7)' : 'gray.300'}>{description}</Text>}
        <HStack alignItems={'flex-end'}>
          <TextBlock paddingTop="16px" marginRight={'-5px'} lineHeight={'48px'} fontSize="64px" weight="bold">
            ${VALUE[pricingPlan]}
          </TextBlock>
          <TextBlock fontSize="16px" color={featured ? 'rgba(255,255,255,0.7)' : 'gray.300'}>
            / {TERM[pricingPlan]}
          </TextBlock>
        </HStack>
      </VStack>
      <List padding="10px 20px 30px">
        <TextBlock weight="bold" fontSize={'14px'} paddingBottom="10px">
          This plan includes:
        </TextBlock>
        {points.map((point, index) => (
          <ListItem key={index} listStylePos="initial" listStyleType={'initial'} fontSize={'14px'} margin="0 20px">
            {point}
          </ListItem>
        ))}
      </List>
    </VStack>
  );
};
